var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-payment"},[_c('PaymentInfo',{attrs:{"isPdf":true,"ids":_vm.$route.query.ids ? _vm.$route.query.ids.split(',') : []}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }